import { Text } from '@mantine/core';

/** Body Image create-config has no scenario fields — devices only. */
export function BodyImageQuickForm() {
  return (
    <Text size='xs' c='dimmed'>
      Config fissa body-image. Seleziona solo i dispositivi e crea la sessione.
    </Text>
  );
}
